// import React from "react";
// import { Navigate, Outlet } from "react-router-dom";
// import { routePathStripPublicUrl } from "../utils/appPath";
// import { loginPath } from "../utils/meetingHubAuth";

// function readBool(key) {
//   try {
//     return JSON.parse(localStorage.getItem(key));
//   } catch {
//     return false;
//   }
// }

// const PrivateRoute = () => {
//   const login = readBool("login");
//   const authenticated = readBool("authenticated");
//   return login || authenticated ? (
//     <Outlet />
//   ) : (
//     <Navigate to={`/${routePathStripPublicUrl(loginPath())}`} replace />
//   );
// };

// export default PrivateRoute;

import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { routePathStripPublicUrl } from "../utils/appPath";
import { loginPath } from "../utils/meetingHubAuth";

function readBool(key) {
  try {
    return JSON.parse(localStorage.getItem(key));
  } catch {
    return false;
  }
}

const PrivateRoute = () => {
  const token = localStorage.getItem("token");
  return token ? (
    <Outlet />
  ) : (
    <Navigate to={`/${routePathStripPublicUrl(loginPath())}`} replace />
  );
};

export default PrivateRoute;
